var _rect, _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModule2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 59,
    viewBox: "0 0 68 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.2227,
    y: 44.5884,
    width: 17,
    height: 4,
    rx: 2,
    stroke: "black",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4832_7400",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4961 51.5884C26.4961 51.0362 26.9438 50.5884 27.4961 50.5884H39.9512C40.5035 50.5884 40.9512 51.0362 40.9512 51.5884V55.3748C40.9512 57.0317 39.608 58.3748 37.9512 58.3748H29.4961C27.8392 58.3748 26.4961 57.0317 26.4961 55.3748V51.5884Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4961 50.5884H40.9512H26.4961ZM42.9512 55.3748C42.9512 58.1362 40.7126 60.3748 37.9512 60.3748H29.4961C26.7347 60.3748 24.4961 58.1362 24.4961 55.3748H28.4961C28.4961 55.9271 28.9438 56.3748 29.4961 56.3748H37.9512C38.5035 56.3748 38.9512 55.9271 38.9512 55.3748H42.9512ZM29.4961 60.3748C26.7347 60.3748 24.4961 58.1362 24.4961 55.3748V53.5884C24.4961 51.9316 25.8392 50.5884 27.4961 50.5884H28.4961C28.4961 50.5884 28.4961 51.0362 28.4961 51.5884V55.3748C28.4961 55.9271 28.9438 56.3748 29.4961 56.3748V60.3748ZM39.9512 50.5884C41.608 50.5884 42.9512 51.9316 42.9512 53.5884V55.3748C42.9512 58.1362 40.7126 60.3748 37.9512 60.3748V56.3748C38.5035 56.3748 38.9512 55.9271 38.9512 55.3748V51.5884C38.9512 51.0362 38.9512 50.5884 38.9512 50.5884H39.9512Z",
    fill: "black",
    mask: "url(#path-2-inside-1_4832_7400)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7804 41.4329C24.7791 41.4874 24.8003 41.538 24.8275 41.5688C24.8397 41.5826 24.8486 41.5874 24.8505 41.5883C24.8507 41.5884 24.8506 41.5884 24.8505 41.5884C24.8505 41.5884 24.8505 41.5884 24.8514 41.5884H42.4153C42.4154 41.5884 42.4155 41.5884 42.4156 41.5884C42.418 41.5871 42.4256 41.5823 42.4356 41.5705C42.4607 41.5407 42.4783 41.4934 42.4745 41.4441C42.1921 37.7828 44.0035 34.8949 45.6747 32.2307C45.6987 32.1924 45.7228 32.1541 45.7468 32.1158C47.4846 29.3445 49.0979 26.7289 49.0912 23.3103C49.0757 15.3165 49.0153 9.20467 43.0676 4.96675C37.0569 0.684052 30.236 0.664616 24.2488 4.96457C18.378 9.18092 18.3667 15.2234 18.3519 23.1259L18.3516 23.3103C18.345 26.7355 19.8502 29.5401 21.4838 32.3912C21.5677 32.5376 21.6521 32.6844 21.7369 32.8317C23.2509 35.4636 24.8581 38.2575 24.7804 41.4329Z",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35.5267L59.8165 42.1046",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8164 35.5267L6.99987 42.1046",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 23.5898H12.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 23.5898H66.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8164 10.1046L6.99987 3.52673",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51 10.1046L59.8165 3.52673",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule2);
export default __webpack_public_path__ + "static/media/module2.1050327b69d580e0dff8716e42ba6f98.svg";
export { ForwardRef as ReactComponent };